<template>
    <div class="goodsFormContent">
         <!-- 面包屑 -->
         <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: $route.query.type == '1' ? `/goods/detail?id=${$route.query.id}` : `/service/detail?id=$route.query.id`  }">{{ $route.query.type == '1' ? '商品详情' : '服务详情' }}</el-breadcrumb-item>
                <el-breadcrumb-item>表单提交</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 表单 -->
        <div class="formBox">
            <div class="formHistoryList" v-if="$route.query.type == '1'">
                <div class="formHistoryTitle">历史记录</div>
                <div class="formHistoryBox flex">
                    <div :class="['formHistory',historyActive == index ? 'formHistoryOn' : '']" v-for="(item,index) in historyData" :key="index" @click="formHistoryTap(index)">{{ item.name }}</div>
                </div>
            </div>
            <div class="formItem" v-for="(item,index) in formData" :key="index">
                <!-- 标题 -->
                <div class="formTitle" v-if="item.type != 'readonly'"><span v-if="item.type != 'text1'">*</span>{{ item.name }}</div>
                <!-- 输入框 -->
                <el-input v-model="item.value" :placeholder="'请输入' + item.name" class="formIpt" v-if="item.type == 'text' || item.type == 'text1'"></el-input>
                <!-- 只读 -->
                <div class="readonly flex" v-if="item.type == 'readonly'">
                    <div class="onlyTitle">{{ item.name }}</div>
                    <el-input v-model="item.value" :disabled="true" type="textarea" resize="none" autosize class="onlyIpt"></el-input>
                    <div class="onlyTips">*不可编辑</div>
                </div>
                <!-- 下拉框 -->
                <el-select v-model="item.active" :placeholder="'请选择' + item.name" v-if="item.type == 'select'" class="formIpt">
                    <el-option v-for="el in item.value" :key="el" :label="el" :value="el">
                    </el-option>
                </el-select>
                <!-- 上传图片 -->
                <div class="uploadBox align"  v-if="item.type == 'img'">
                    <el-upload action="/api/common/upload" :limit="1" list-type="picture-card" :file-list="item.va
                    " :on-exceed="overstep" :on-success="function (res, file){return uploadImg(res, file, index)}" :on-remove="function (res, file){return removeImg(res, file, index)}" v-if="item.type == 'img'">
                        <i class="el-icon-upload"></i>
                        <div :slot="item.name" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" >
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                    <div class="uploadTips">{{ '请上传' + item.name }}</div>
                </div>
                <!-- 验证码 -->
                <div class="flex" v-if="item.type == 'code'">
                    <el-input v-model="item.phone" placeholder="请输入手机号" :maxlength="11" class="formIpt"></el-input>
                    <div class="codeIptBox">
                        <el-input v-model="item.value" placeholder="请输入验证码" class="formIpt"></el-input>
                        <div :class="['codeBtn' , gain ? '' : 'codeBtnNo']" @click="codeBtnTap(index)">{{ time == '0' ? '获取验证码' : time + 's' }}</div>
                    </div>
                </div>
            </div>
            <!-- 提示 -->
            <div class="formTips align">
                <el-image :src="require('@/assets/icon/tips.png')" fit="cover" class="tipsIcon"></el-image>
                <div class="tips">注：以上信息收集仅用于为您提供更全面的个性化服务，不会用作其他用途。</div>
            </div>
            <div class="formBtn" @click="formSubmit">提交</div>
        </div>
        <!-- 支付弹窗 -->
        <el-dialog title="扫码支付" :visible.sync="dialogShow" width="20%" :before-close="handleClose">
            <div class="align">
                <el-image v-if="payData.code" :src="payData.code" fit="cover" class="payImg"></el-image>
            </div>
        </el-dialog>
         <!-- 扫码弹窗 -->
         <el-dialog title="将商品添加到视频号达人橱窗" :visible.sync="empower" width="30%" :before-close="handleClose">
            <div class="align">
                <el-image v-if="empowerData.xcx_code" :src="empowerData.xcx_code" fit="cover" class="payImg"></el-image>
            </div>
            <div class="empowerTips">请扫上方小程序码</div>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                userDetail: 0,
                formData: {},
                dialogImageUrl: '',
                dialogVisible: false,
                gain: true,
                time: 0,
                payData: {},
                dialogShow: false,
                payTime: '',
                empowerData: {},
                empower: false,
                historyData: [],
                historyActive: 0
            }
        },
        beforeDestroy(){
            clearInterval(this.payTime)
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            if(!this.userDetail){
                this.$router.push({ path:'/login/login' })
            }
            this.getServiceForm()
        },
        methods: {
            // 获取表单详情
            getServiceForm(){
                this.request.get(`index/${this.$route.query.type == '1' ? 'goods' : 'fuwu'}/confirm`,{
                    params:{
                        id: this.$route.query.id
                    }
                })
                .then(res=>{
                    res.data.form.map((el,index) => {
                        if(el.type == 'text' || el.type == 'text1'){
                            el.value = ''
                        }
                        if(el.type == 'img'){
                            el.value = []
                        }
                        if(el.type == 'code'){
                            el.value = ''
                            el.phone = ''
                        }
                        if(el.type == 'select'){
                            el.active = ''
                        }
                    })
                    this.formData = res.data.form
                    if(this.$route.query.type == '1'){
                        this.getHistory()
                    }
                })
            },
            // 获取历史记录
            getHistory(){
                this.request.get("api/chuchuang/history",{
                    params:{
                        userid: this.userDetail.userid
                    }
                })
                .then(res=>{
                    if(res.data.length > 0){
                        this.formData[0].value = res.data[0].finder_id
				        this.formData[1].value = res.data[0].name
                        this.historyData = res.data
                    }
                })
            },
            // 点击历史记录
            formHistoryTap(e){
                this.formData[0].value = this.historyData[e].finder_id
				this.formData[1].value = this.historyData[e].name
                this.historyActive = e
            },
            // 上传图片
            uploadImg(res, file, index){
                this.formData[index].value.push(res.data.fullurl)
            },
            // 删除图片
            removeImg(res, file, index){
                this.formData[index].value = []
            },
            // 文件超出个数限制
            overstep(){
                this.$message({
                    message: '最多上传一张图片',
                    type: 'warning'
                });
            },
            // 获取验证码
            codeBtnTap(e){
                let tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                if(!tel.test(this.formData[e].phone)){
                    this.$message({
                        message: '请输入正确的手机号码',
                        type: 'warning'
                    });
                    return
				}
                var that = this
                if(that.gain){
                    this.request.get("api/common/sendSms",{
                        params:{
                            mobile: this.formData[e].phone,
                            timeStamp: parseInt(new Date().getTime() / 1000)
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            that.time = 60
                            that.gain = false
                            var count = setInterval(function(){
                                that.time--
                                if(that.time == 0){
                                    that.gain = true
                                    clearInterval(count)
                                }
                            },1000)
                        }else{
                            this.$message.error(res.msg);
                        }
                        
                    })
                    
                }
            },
            // 提交表单
			formSubmit(){
				let arr = []
                let tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                for (var index = 0; index < this.formData.length; index++){
                    let el = this.formData[index]
                    if(((el.type == 'text' || el.type == 'select') && el.value == '') || (el.type == 'code' && (el.value == '' || el.phone == '')) || (el.type == 'img' && el.value.length == '0')){
                        this.$message({
                            message: '请填写完整信息',
                            type: 'warning'
                        });
                        return false
					}else if(el.type == 'code' && !tel.test(el.phone)){
                        this.$message({
                            message: '请输入正确的手机号码',
                            type: 'warning'
                        });
                        return false
					}else{
						let obj = {}
						if(el.type == 'text' || el.type == 'text1' || el.type == 'readonly'){
							obj.name = el.name
							obj.value = el.value
						}
                        if(el.type == 'img'){
							obj.name = el.name
							obj.value = el.value.join(',')
						}
						if(el.type == 'code'){
							obj.name = el.name
							obj.value = el.value
							obj.phone = el.phone
						}
						if(el.type == 'select'){
							obj.name = el.name
							obj.value = el.active
						}
						obj.type = el.type
						arr.push(obj)
					}
                }
                if(this.$route.query.type == '1'){
                    this.request.get("api/chuchuang/promoteradd",{
                        params:{
                            id: this.$route.query.id,
                            userid: this.userDetail.userid,
                            form: JSON.stringify(arr),
                            timeStamp: parseInt(new Date().getTime() / 1000)
                        }
                    })
                    .then(res=>{
                        if(res.code != '0'){
                            if(res.code != '5'){
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                            }
                            if(res.code == '1'){
                                setTimeout(()=>{
                                    this.$router.go(-1)
                                },1000)
                            }
                            if(res.code == '5'){
                                this.empowerData = res.data
                                this.$confirm(res.content, '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    this.empower = true
                                }).catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: '已取消'
                                    });          
                                });
                                console.log(this.empowerData)
                            }
                            this.getHistory()
                        }else{
                            this.$message.error(res.msg);
                        }
                    })
                }
                if(this.$route.query.type == '2'){
                    this.request.get("index/fuwu/pay",{
                        params:{
                            goods_id: this.$route.query.id,
                            userid: this.userDetail.userid,
                            form: JSON.stringify(arr),
                            dif: 1,
                            spec_id: this.$route.query.specId
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message.error(res.msg);
                        }
                        if(res.code == '1'){
                            this.payData = res.data
                            this.dialogShow = true
                            this.getPayType()
                        }
                        if(res.code == '5'){
                            this.getZeropay(res.data.order_num)
                        }
                    })
                }
			},
            // 零元支付
            getZeropay(e){
                this.request.get("index/fuwu/zeropay",{
                    params:{
                        order_num: e
                    }
                })
                .then(res=>{
                    if(res.code){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        setTimeout(()=>{
                            this.$router.push({ path:'/my/my', query:{type: 'orderDetail',id:e } })
                        },1000)
                    }
                    if(res.code == '0'){
                        this.$message.error(res.msg);
                    }
                })
            },
            // 获取支付结果
            getPayType(){
                this.payTime = window.setInterval(() => {
                    this.request.get("index/fuwu/getorderstatus",{
                        params:{
                            order_num: this.payData.order_num,
                            timeStamp: parseInt(new Date().getTime() / 1000)
                        }
                    })
                    .then(res=>{
                        if(res.code){
                            clearInterval(this.payTime)
                            this.dialogShow = false
                            this.$message({
                                message: '支付成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                this.$router.push({ path:'/my/my', query:{type: 'orderDetail',id:this.payData.order_num } })
                            },1000)
                        }
                    })
                    .catch(err=>{
                        clearInterval(this.payTime)
                    })
                }, 2000);
            },
            // 关闭弹窗回调
            handleClose(done){
                clearInterval(this.payTime)
                done()
            }
        }
    }
</script>
<style lang="less" scoped>
    .goodsFormContent{
        width: 100vw;
        background: #FAFBFC;
        padding-bottom: 108px;
        .formBox{
            width: 1228px;
            padding: 0 38px;
            border-radius: 10px;
            background: #fff;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            .formHistoryList{
                display: flex;
                padding-top: 27px;
                .formHistoryTitle{
                    font: 14px/44px "Microsoft YaHei";
                    color: #464646;
                    padding-right: 10px;
                }
                .formHistoryBox{
                    flex: 1;
                    .formHistory{
                        padding: 0 14px;
                        height: 32px;
                        border: 1px solid #E8E9EC;
                        border-radius: 17px;
                        font: 14px/32px "Microsoft YaHei";
                        color: #7A7B7A;
                        margin: 5px 0 5px 20px;
                        cursor: pointer;
                    }
                    .formHistoryOn{
                        border: 1px solid #FF6A00 !important;
                        color: #FF6A00 !important;
                    }
                }
            }
            .formItem{
                .formTitle{
                    padding-top: 40px;
                    font: 14px/14px "Microsoft YaHei";
                    color: #464646;
                    span{
                        color: #FF6A00;
                    }
                }
                .formIpt{
                    width: 422px;
                    height: 30px;
                    margin-top: 20px;
                    /deep/ .el-input__inner{
                        border: none;
                        padding: 0;
                        border-bottom: 2px solid #E3E3E8;
                        border-radius: 0;
                    } 
                }
                .readonly{
                    padding-top: 40px;
                    .onlyTitle{
                        font: 14px/36px "Microsoft YaHei";
                        color: #464646;
                    }
                    .onlyIpt{
                        width: 450px;
                        height: 36px;
                        margin-left: 30px;
                    }
                    .onlyTips{
                        font: 14px/36px "Microsoft YaHei";
                        color: #FF6A00;
                        margin-left: 14px;
                    }
                }
                .uploadBox{
                    padding-top: 28px;
                    .uploadTips{
                        font: 14px/14px "Microsoft YaHei";
                        color: #A9A9A9;
                        margin-left: 10px;
                    }
                }
                .codeIptBox{
                    width: 422px;
                    height: 50px;
                    position: relative;
                    margin-left: 100px;
                    .codeBtn{
                        width: 106px;
                        height: 32px;
                        border-radius: 17px;
                        font: 14px/32px "Microsoft YaHei";
                        color: #FF730F;
                        border: 1px solid #FF730F;
                        text-align: center;
                        position: absolute;
                        right: 2px;
                        top: 20px;
                        cursor: pointer;
                    }
                    .codeBtnNo{
                        color: #c6c6c6 !important;
                        border: 1px solid #c6c6c6 !important;
                        cursor: default !important;
                    }
                }
            }
        .formTips{
                margin-top: 43px;
                .tipsIcon{
                    width: 16px;
                    height: 16px;
                }
                .tips{
                    font: 14px/14px "Microsoft YaHei";
                    padding-left: 6px;
                    color: #464646;
                }
            }
            .formBtn{
                width: 240px;
                height: 48px;
                background: #FF6A00;
                border-radius: 4px;
                font: 15px/48px "Microsoft YaHei";
                color: #fff;
                text-align: center;
                margin: 65px auto 50px auto;
                cursor: pointer;
            }
        }
        .payImg{
            margin: 0 auto;
        }
        .empowerTips{
            font: 14px/14px "Microsoft YaHei";
            padding-top: 24px;
            text-align: center;
            color: #AFAFAF;
        }
    }
</style>